module.exports = __webpack_public_path__ + "static/media/20210212_202245_797_IMG_2104.00b08961.jpg";